import { PAGE_URLS } from "../../constants/hrefLinks"
import { API_URL } from "../../constants/pathConstants"
import { userStateData } from "../../data/userStateData"
import { ChatInteractions, CreateInteractionResponse, InstructorUserDetailsRequestResponse, InteractionsRequestResponse } from "../types"

class InteractionConnector {
	requestInProgress: boolean = false

	public async updateInteractionRequest(id: string, interaction_data: string, status: string | undefined): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConntor] updateInteractionRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}update-interaction-data`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"interaction_data": interaction_data,
						"status": status
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConntor] - updateInteractionRequest() failed')
			console.log(err)
			return false
		}
	}

	public async interactionAddMessageRequest(id: string, instructor_message: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConntor] interactionAddMessageRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}interaction-add-instructor-message`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"instructor_message": instructor_message,
						"instructorIconUrl": userStateData.getUserIconUrl()
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConntor] - interactionAddMessageRequest() failed')
			console.log(err)
			return false
		}
	}

	public async interactionAddVideoRequest(id: string, instructor_videos: string[]): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConntor] interactionAddMessageRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}interaction-add-instructor-video`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"instructor_videos": instructor_videos,
						"instructorIconUrl": userStateData.getUserIconUrl()
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
							// userStateData.interactions
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConntor] - interactionAddMessageRequest() failed')
			console.log(err)
			return false
		}
	}

	public async updateInteractionStatusRequest(id: string, status: string | undefined, instructorId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConntor] updateInteractionRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}update-interaction-status`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"status": status,
						"instructorId": instructorId
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConntor] - updateInteractionRequest() failed')
			console.log(err)
			return false
		}
	}

	public async addReviewRequest(instructorId: string, customerId: string, review: string, rating: number): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConntor] updateInteractionRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}create-new-review`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"customer_id": customerId,
						"instructor_id": instructorId,
						"review": review,
						"rating": rating
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConntor] - updateInteractionRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performGetInteractionRequest(interactionId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConnector] performGetCustomerInteractionsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const interactionUrlParams = new URLSearchParams()
				interactionUrlParams.append("interactions", interactionId)
				let userInteractions: ChatInteractions[] = []

				await fetch(`${API_URL}get-interactions?${interactionUrlParams}`)
					.then((res) => res.json())
					.then((data: InteractionsRequestResponse) => {
						if (data.interactions) {
							// userStateData.setInteractions(data.interactions)
							data.interactions.forEach((interaction: ChatInteractions) => userInteractions.push(interaction))
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
					if (userInteractions.length > 0) {
						// Get all instructor ids
						if (userStateData.isAnInstructor()) {
							let customerId: string = userInteractions[0].customer_id

							const customerUrlParams = new URLSearchParams()
							customerUrlParams.append("customerIds", customerId)
							
							await fetch(`${API_URL}get-customer-details?${customerUrlParams}`)
								.then((res) => res.json())
								.then((data: InstructorUserDetailsRequestResponse) => {
									if (data.userDetails) {
										for (let i:number = 0; i < userInteractions.length; i++) {
											for (let j: number = 0; j < data.userDetails.length; j++) {
												if (userInteractions[i].customer_id == data.userDetails[j].id) {
													userInteractions[i].otherUserDetails = data.userDetails[j]
													break
												}
											}
										}
										userStateData.setInteractions(userInteractions)
									}
								})
								.catch((error) => {
									console.log(error)
								})
						} else {
							let instructorId: string = userInteractions[0].instructor_id

							const instructorUrlParams = new URLSearchParams()
							instructorUrlParams.append("instructorIds", instructorId)
							
							await fetch(`${API_URL}get-instructor-details?${instructorUrlParams}`)
								.then((res) => res.json())
								.then((data: InstructorUserDetailsRequestResponse) => {
									if (data.userDetails) {
										for (let i:number = 0; i < userInteractions.length; i++) {
											for (let j: number = 0; j < data.userDetails.length; j++) {
												if (userInteractions[i].instructor_id == data.userDetails[j].id) {
													userInteractions[i].otherUserDetails = data.userDetails[j]
													break
												}
											}
										}
										userStateData.setInteractions(userInteractions)
									}
								})
								.catch((error) => {
									console.log(error)
								})
						}
					}

				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConnector] - performGetCustomerInteractionsRequest() failed')
			console.log(err)
			return false
		}
	}

	/**
	 * Perform an api request to obtain interaction data for the given customer
	 * @param customerId - id of the customer
	 * @returns Promise boolean indicating request success status on complete
	 */
	public async performGetCustomerInteractionsRequest(customerId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConnector] performGetCustomerInteractionsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const interactionUrlParams = new URLSearchParams()
				interactionUrlParams.append("customerId", customerId)
				let userInteractions: ChatInteractions[] = []

				await fetch(`${API_URL}get-customer-interactions?${interactionUrlParams}`)
					.then((res) => res.json())
					.then((data: InteractionsRequestResponse) => {
						if (data.interactions) {
							// userStateData.setInteractions(data.interactions)
							data.interactions.forEach((interaction: ChatInteractions) => userInteractions.push(interaction))
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				if (userInteractions.length > 0) {
					// Get all instructor ids
					let instructorIds: string[] = []
					userInteractions.forEach((interaction: ChatInteractions) => {
						if (!instructorIds.includes(interaction.instructor_id)) {
							instructorIds.push(interaction.instructor_id)
						}
					})
					// Create url params
					const instructorUrlParams = new URLSearchParams()
					instructorUrlParams.append("instructorIds", instructorIds.join(','))
					
					await fetch(`${API_URL}get-instructor-details?${instructorUrlParams}`)
						.then((res) => res.json())
						.then((data: InstructorUserDetailsRequestResponse) => {
							if (data.userDetails) {
								// userStateData.setInteractions(data.interactions)
								// data.interactions.forEach((interaction: ChatInteractions) => userInteractions.push(interaction))
								for (let i:number = 0; i < userInteractions.length; i++) {
									for (let j: number = 0; j < data.userDetails.length; j++) {
										if (userInteractions[i].instructor_id == data.userDetails[j].id) {
											userInteractions[i].otherUserDetails = data.userDetails[j]
											break
										}
									}
								}
								userStateData.setInteractions(userInteractions)
							}
						})
						.catch((error) => {
							console.log(error)
						})
				}

				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConnector] - performGetCustomerInteractionsRequest() failed')
			console.log(err)
			return false
		}
	}

	/**
	 * Perform an api request to obtain interaction data for the given customer
	 * @param customerId - id of the customer
	 * @returns Promise boolean indicating request success status on complete
	 */
	public async performGetInstructorInteractionsRequest(instructorId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConnector] performGetCustomerInteractionsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const interactionUrlParams = new URLSearchParams()
				interactionUrlParams.append("instructorId", instructorId)
				let userInteractions: ChatInteractions[] = []

				await fetch(`${API_URL}get-instructor-interactions?${interactionUrlParams}`)
					.then((res) => res.json())
					.then((data: InteractionsRequestResponse) => {
						if (data.interactions) {
							data.interactions.forEach((interaction: ChatInteractions) => userInteractions.push(interaction))
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				if (userInteractions.length > 0) {
					// Get all instructor ids
					let customerIds: string[] = []
					userInteractions.forEach((interaction: ChatInteractions) => {
						if (!customerIds.includes(interaction.customer_id)) {
							customerIds.push(interaction.customer_id)
						}
					})
					// Create url params
					const customerUrlParams = new URLSearchParams()
					customerUrlParams.append("customerIds", customerIds.join(','))
					
					await fetch(`${API_URL}get-customer-details?${customerUrlParams}`)
						.then((res) => res.json())
						.then((data: InstructorUserDetailsRequestResponse) => {
							if (data.userDetails) {
								for (let i:number = 0; i < userInteractions.length; i++) {
									for (let j: number = 0; j < data.userDetails.length; j++) {
										if (userInteractions[i].customer_id == data.userDetails[j].id) {
											userInteractions[i].otherUserDetails = data.userDetails[j]
											break
										}
									}
								}
								userStateData.setInteractions(userInteractions)
							}
						})
						.catch((error) => {
							console.log(error)
						})
				}

				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConnector] - performGetCustomerInteractionsRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performGetFavInstructorRequest(instructorIdsStr: string):  Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConnector] performGetFavInstructorRequest() called while request is in process')
				return false
			} else {
				// Check to make sure the given string has ids to request
				const instructorIds: string[] = instructorIdsStr.split(',')
				let invalidIdFound: boolean = false
				instructorIds.forEach((str: string) => {
					if (str.length < 1) {
						invalidIdFound = true
					}
				})
				if (invalidIdFound) {
					console.log('WARNING - [InteractionConnector] performGetFavInstructorRequest() invalid id found in interactionStr')
					return false
				}
				
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("instructorIds", instructorIdsStr)

				await fetch(`${API_URL}get-instructor-details?${urlParams}`)
					.then((res) => res.json())
					.then((data: InstructorUserDetailsRequestResponse) => {
						if (data.userDetails) {
							userStateData.setLikedInstructorDetails(data.userDetails)
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConnector] - performGetFavInstructorRequest() failed')
			console.log(err)
			return false
		}
	}

	/**
	 * Perform an api request to obtain interaction data for the given ids
	 * @param interactionsStr - comma seperated list of interaction ids
	 * @returns Promise boolean indicating request success status on complete
	 */
	public async performGetInteractionsRequest(interactionsStr: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConnector] performGetInteractionsRequest() called while request is in process')
				return false
			} else {
				// Check to make sure the given string has ids to request
				const interactionIds: string[] = interactionsStr.split(',')
				let invalidIdFound: boolean = false
				interactionIds.forEach((str: string) => {
					if (str.length < 1) {
						invalidIdFound = true
					}
				})
				if (invalidIdFound) {
					console.log('WARNING - [InteractionConnector] performGetInteractionsRequest() invalid id found in interactionStr')
					return false
				}
				
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("interactions", interactionsStr)

				await fetch(`${API_URL}get-interactions?${urlParams}`)
					.then((res) => res.json())
					.then((data: InteractionsRequestResponse) => {
						if (data.interactions) {
							userStateData.setInteractions(data.interactions)
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConnector] - performGetInteractionsRequest() failed')
			console.log(err)
			return false
		}
	}

	// public async performCreateInteractionRequest(instructorId: string, customerId: string):  Promise<boolean> {
	// 	try {
	// 		if (this.requestInProgress) {
	// 			console.log('WARNING - [InteractionConnector] performCreateInteractionRequest() called while request is in process')
	// 			return false
	// 		} else {
	// 			this.requestInProgress = true
	// 			const urlParams = new URLSearchParams()
	// 			urlParams.append("instructorId", instructorId)
	// 			urlParams.append("customerId", customerId)

	// 			await fetch(`${API_URL}create-new-interaction?${urlParams}`)
	// 				.then((res) => res.json())
	// 				.then((data: CreateInteractionResponse) => {
	// 					if (data.status) {
	// 						window.location.replace('/')
	// 					}
	// 				})
	// 				.catch((error) => {
	// 					console.log(error)
	// 				})
				
	// 			this.requestInProgress = false
	// 			return true
	// 		}
	// 		// return true
	// 	} catch(err) {
	// 		this.requestInProgress = false
	// 		console.log('[InteractionConnector] - performGetFavInstructorRequest() failed')
	// 		console.log(err)
	// 		return false
	// 	}
	// }

	public async performCreateVideoInteractionRequest(instructorId: string, customerId: string, interactionData: string, amount: string):  Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConnector] performCreateInteractionRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}create-new-video-interaction`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"instructorId": instructorId,
						"customerId": customerId,
						"interactionData": interactionData,
						"amount": amount
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.data?.transaction?.url) {
							// console.log(data.data)
							userStateData.transactionUrl = data.data.transaction.url
						} else if (data.data?.transaction?.complete == true) {
							userStateData.transactionUrl = PAGE_URLS.DASHBOARD_CUSTOMER
						}
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConnector] - performGetFavInstructorRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performTipInteractionRequest(interactionId: string, amount: number):  Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConnector] performCreateInteractionRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}tip-interaction`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"interactionId": interactionId,
						"amount": amount
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.data?.transaction?.url) {
							// console.log(data.data)
							userStateData.transactionUrl = data.data.transaction.url
						}
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConnector] - performGetFavInstructorRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const interactionConnector: InteractionConnector = new InteractionConnector()